// extracted by mini-css-extract-plugin
module.exports = {"tip-wrapper":"tip_box__tip-wrapper___YYeAO","tip-icon":"tip_box__tip-icon___2u9Ed","tip-text":"tip_box__tip-text___qGH2R"};